export const REPORTNOTIFS_GET = 'REPORTNOTIFS_GET';
export const REPORTNOTIF_GET = 'REPORTNOTIF_GET';
export const REPORTNOTIF_DELETE = 'REPORTNOTIF_DELETE';
